import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import Sector from "../Dropdowns/Sector";
import axiosInstance from "../../axios";
import {toast} from 'react-toastify'
export default function UpdateProduct({
  updateProductData,
  updateModalSetting,
  handlePageUpdate
}) {
  const {
     course_id,
     course_name,
     course_code,
     affli_certificate,
     mess_equivalance,
     aff_agency,
     cost,
     sector_id ,
     smart_aff_certi,
     reas_for_rej,
     min_quali,
     job_role_name,
     job_role_cate,
     version,
     job_role_id,
     core_skill_hour,
     soft_skill_hour,
     ojt_hour,
     bridge_hour,
     cost_cate,
     admin_status

     
  } = updateProductData;
  const [sector ,setSector]=useState(sector_id)
  const[aff,setAff]=useState(affli_certificate)
  const dont=true
  const[smart,setSmart]=useState(smart_aff_certi)
  const [status,setStatus]=useState(admin_status)
  const [formData, setFormData] = useState({
    course_name:course_name,
    course_code:course_code,
    mess_equivalance:mess_equivalance,
    aff_agency:aff_agency,
    admin_status:admin_status,
    reas_for_rej:reas_for_rej,
    min_quali:min_quali,
    job_role_name:job_role_name,
    job_role_id: job_role_id,
    job_role_cate:job_role_cate,
    version: version,
    cost:cost,
    cost_cate: cost_cate,
    soft_skill_hour: soft_skill_hour,
    core_skill_hour: core_skill_hour,
    ojt_hour: ojt_hour,
    bridge_hour: bridge_hour,

  });
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);

  const handleFileChange=(e)=>{
    setAff(e.target.files[0]);
  }
  const handleSmartChange=(e)=>{
    setSmart(e.target.files[0]);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const updateProduct = () => {
    if(status==='Not Accepted' && formData.reas_for_rej===''){
      toast.error('Please Give Reason for Rejection')
      return;
    }
    const form=new FormData()
    form.append('affli_certificate',aff||'')
    form.append('smart_aff_certi',smart||'')
    form.append('course_name', formData.course_name);
    form.append('course_code', formData.course_code);
    form.append('mess_equivalance', formData.mess_equivalance);
    form.append('aff_agency', formData.aff_agency);
    form.append('cost', formData.cost);
    form.append('admin_status', status);
    form.append('reas_for_rej', formData.reas_for_rej);
    form.append('min_quali', formData.min_quali);
    form.append('job_role_name', formData.job_role_name);
    form.append('job_role_id', formData.job_role_id);
    form.append('job_role_cate', formData.job_role_cate);
    form.append('version',formData.version);
    form.append('core_skill_hour', formData.core_skill_hour);
    form.append('soft_skill_hour', formData.soft_skill_hour);
    form.append('ojt_hour', formData.ojt_hour);
    form.append('bridge_hour', formData.bridge_hour);
    form.append('sector_id',sector);
    form.append('cost_cate', formData.cost_cate);
    axiosInstance.put(`/courses/update/${course_id}`,form)
     .then((res) => {
        toast.success('Course Updated')
        //updateProductData(res.data);
        handlePageUpdate();
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error('Failed to update Course')
      });
    // Your code for updating product goes here
    // Close the modal after successful update
    setOpen(false);
  }

  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left 
              shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Update Course
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                       
      <div>
      <Sector value={sector} handleInputChange={(e)=>setSector(e.target.value)} />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Course Code</label>
        <input
          type="text"
          name="course_code"
          value={course_code}
          onChange={handleChange}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          disabled
                                  aria-autocomplete="true" 

        />
      </div>
     
      <div>
                            <label htmlFor="aff"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Afflilation Certificate</label>
                            <label
        htmlFor="aff"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {aff?.name && aff.name.length > 8
            ? aff.name.substring(0, 8) + "..."
            : aff?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="aff"
        className="hidden"
        accept=".pdf"
        
        aria-autocomplete="true" 
        onChange={handleFileChange}
      />
                          </div>
      <div>
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">MES_SSC Equivalence</label>
        <input
          type="text"
          name="mess_equivalance"
          value={formData.mess_equivalance}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />  
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Affilation Agency</label>
        <input
          type="text"
          name="aff_agency"
          value={formData.aff_agency}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
  
      <div>
                            <label htmlFor="smart"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >SMART Aff. Equivalence</label>
                            <label
        htmlFor="smart"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {smart?.name && smart.name.length > 8
            ? smart.name.substring(0, 8) + "..."
            : smart?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="smart"
        className="hidden"
        accept=".pdf"
        required
        onChange={handleSmartChange}
      />
                          </div>
                          <div>
                            <label htmlFor="status"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Admin Status</label>
                                <select
                id="status"
                value={status}
                onChange={e=>setStatus(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>------Select-----</option>
                <option value="Accepted">Accepted</option>
                <option value="Not Accepted">Not Accepted</option>
               


            </select>
                            </div>
      {status==='Not Accepted' &&(
        <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Rejection Reason <span className="text-red-600">*</span></label>
        <input
          type="text"
          name="reas_for_rej"
          value={formData.reas_for_rej}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      )}
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Minimum Qualification</label>
        <input
          type="text"
          name="min_quali"
          value={formData.min_quali}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Job Role ID</label>
        <input
          type="text"
          name="job_role_id"
          value={formData.job_role_id}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>  
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Job Role Name</label>
        <input
          type="text"
          name="job_role_name"
          value={formData.job_role_name}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Job Role Category</label>
        <input
          type="text"
          name="job_role_cate"
          value={formData.job_role_cate}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Version</label>
        <input
          type="text"
          name="version"
          value={formData.version}
          onChange={handleChange}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

          
                                  aria-autocomplete="true" 
        />
      </div>
      
  
                            <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Soft Skills Hours</label>
        <input
          type="number"
          name="soft_skill_hour"
          value={formData.soft_skill_hour}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Core Skills Hours</label>
        <input
          type="number"
          name="core_skill_hour"
          value={formData.core_skill_hour}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">OJT Hours</label>
        <input
          type="number"
          name="ojt_hour"
          value={formData.ojt_hour}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Bridge Hours</label>
        <input
          type="number"
          name="bridge_hour"
          value={formData.bridge_hour}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
     

      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Course Cost</label>
        <input
          type="number"
          name="cost"
          value={formData.cost}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
      <div >
        <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Cost Category</label>
        <input
          type="text"
          name="cost_cate"
          value={formData.cost_cate}
          onChange={handleChange}
          
          aria-autocomplete="true" 
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

        />
      </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={updateProduct}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
